import script from "./RequestNotesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestNotesModal.vue?vue&type=script&setup=true&lang=ts"

import "./RequestNotesModal.vue?vue&type=style&index=0&id=43cfce83&lang=scss"

const __exports__ = script;

export default __exports__